export default __webpack_public_path__ + "static/media/slider7.65907fd8.jpg";